import { createSlice } from "@reduxjs/toolkit";

const websocketSlice = createSlice({
  name: "websocket",
  initialState: {
    connected: false,
    messages: [],
  },
  reducers: {
    wsConnect: (state, action) => {},
    wsDisconnect: (state) => {},
    wsSend: (state, action) => {},
    wsConnected: (state) => {
      state.connected = true;
    },
    wsDisconnected: (state) => {
      state.connected = false;
    },
    wsMessage: (state, action) => {
      state.messages.push(action.payload);
    },
  },
});

export const {
  wsConnect,
  wsDisconnect,
  wsSend,
  wsConnected,
  wsDisconnected,
  wsMessage,
} = websocketSlice.actions;

export default websocketSlice.reducer;